import React from 'react'
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toAbsoluteUrl } from "../../../Utils/_helpers";
import OpcSelect from "../../components/select/src";
import { getAgentNumbers } from "./api";
import { getAgentPhoneForCalling, getName, getSessionUserId } from "./helpers";
import store from '../../../redux/store';
import { isAdmin } from '../../util/helpers';

const UserPhoto = ({ user }) => {
  return (
    <>
      {user.img && user.img !== "" && (
        <span className="">
          <img alt="" src={user.img} className="t-dp" />
        </span>
      )}
      {(!user.img || user.img === "") && (
        <span className="t-dp-initial symbol-label font-size-h5 font-weight-bold">
          {user.name[0].toLocaleUpperCase()}
        </span>
      )}
    </>
  );
};

const getTelIcon = (agent) => {
  if (agent) {
    return <UserPhoto user={{ name: agent.first_name }} />;
  }
  return (
    <span className="">
      <img
        alt=""
        className="t-dp"
        src={toAbsoluteUrl("/media/sr/icons/sr_number.svg")}
      />
    </span>
  );
};

export const AgentInput = (props) => {
  const [selected, setSelected] = useState("");
  const onSelect = (code) => {
    setSelected(code);
    reFormatOptions(code);
    props.onEvent({ type: "c2c_form::set", key: "agent_number", value: code });
  };

  const showSelectedLabel = true;
  const showSecondarySelectedLabel = true;
  const showOptionLabel = true;
  const showSecondaryOptionLabel = true;
  const searchable = true;

  const [customLabels, setCustomLabels] = useState({});
  const [valueCodes, setValueCodes] = useState([]);
  const [agentNumbers, setAgentNumbers] = useState([]);
  const [objectList, setObjectList] = useState();
  const dispatch = useDispatch();
  const { ticker: { session_agent_numbers } } = store.getState();

  const findLoggedInAgentById = (user_id, objects) => objects.find(obj => obj.id === user_id);

  const api = async () => {
    try {
      const objects = isAdmin() ? await getAgentNumbers(dispatch) : session_agent_numbers;
      let index = 0;
      if (objects && objects.length > 0) {
        setObjectList(objects);
        const customLabels1 = {};
        const values_codes = [];

        objects.map((agent, i) => {
          if (agent.sip_url_flag) {
            let option = {
              icon: getTelIcon(agent),
              data: agent,
              selectedPrimary:
                props.ticker_initial_agent_number === agent.contact_number
                  ? getName(agent)
                  : agent.id === getSessionUserId() &&
                    !props.ticker_initial_agent_number
                  ? getName(agent)
                  : null,
              primary: getName(agent, 10),
              selectedSecondary:
                props.ticker_initial_agent_number === agent.contact_number
                  ? getAgentPhoneForCalling(agent)
                  : agent.id === getSessionUserId() &&
                    !props.ticker_initial_agent_number
                  ? getAgentPhoneForCalling(agent)
                  : null,
              secondary: getAgentPhoneForCalling(agent, 13),
            };
            let key = agent.phone;
            customLabels1[key] = option;
            values_codes.push(key);
            if (
              props.ticker_initial_agent_number &&
              props.ticker_initial_agent_number === agent.contact_number
            ) {
              index = i + 1;
            } else if (agent.id === getSessionUserId() && !index) {
              index = i + 1;
            }
          } else {
            let option = {
              icon: getTelIcon(agent),
              data: agent,
              selectedPrimary:
                props.ticker_initial_agent_number === agent.contact_number
                  ? getName(agent)
                  : agent.id === getSessionUserId() &&
                    !props.ticker_initial_agent_number
                  ? getName(agent)
                  : null,
              primary: getName(agent, 10),
              selectedSecondary:
                props.ticker_initial_agent_number === agent.contact_number
                  ? getAgentPhoneForCalling(agent)
                  : agent.id === getSessionUserId() &&
                    !props.ticker_initial_agent_number
                  ? getAgentPhoneForCalling(agent)
                  : null,
              secondary: getAgentPhoneForCalling(agent, 13),
            };
            let key = agent.country_code + agent.phone;
            customLabels1[key] = option;
            values_codes.push(key);
            if (
              props.ticker_initial_agent_number &&
              props.ticker_initial_agent_number === agent.contact_number
            ) {
              index = i + 1;
            } else if (agent.id === getSessionUserId() && !index) {
              index = i + 1;
            }
          }
        });
        setValueCodes(values_codes);
        setCustomLabels(customLabels1);
        setAgentNumbers(values_codes);
        const loggedInAgent = findLoggedInAgentById(getSessionUserId(), objects);
        
        if (loggedInAgent['is_active']) {
          if (!selected && !props.ticker_initial_agent_number) {
            setSelected(values_codes[index - 1]);
            onSelect(values_codes[index - 1]);
          } else {
            setSelected(values_codes[index - 1]);
            onSelect(values_codes[index - 1]);
          }
        }
      }
    } catch (error) {
      console.error(error);
      return error.response;
    }
  };
  const reFormatOptions = (opt) => {
    if (objectList && objectList.length > 0) {
      const customLabels1 = {};
      const values_codes = [];
      objectList.map((agent, i) => {
        if (agent.sip_url_flag) {
          let option = {
            icon: getTelIcon(agent),
            data: agent,
            selectedPrimary:
              opt === agent.contact_number ? getName(agent) : null,
            primary: getName(agent, 10),
            selectedSecondary:
              opt === agent.contact_number
                ? getAgentPhoneForCalling(agent)
                : null,
            secondary: getAgentPhoneForCalling(agent, 13),
          };
          let key = agent.phone;
          customLabels1[key] = option;
          values_codes.push(key);
        } else {
          let option = {
            icon: getTelIcon(agent),
            data: agent,
            selectedPrimary:
              opt === agent.contact_number ? getName(agent) : null,
            primary: getName(agent, 10),
            selectedSecondary:
              opt === agent.contact_number
                ? getAgentPhoneForCalling(agent)
                : null,
            secondary: getAgentPhoneForCalling(agent, 13),
          };
          let key = agent.country_code + agent.phone;
          customLabels1[key] = option;
          values_codes.push(key);
        }
      });

      setValueCodes(values_codes);
      setCustomLabels(customLabels1);
      setAgentNumbers(values_codes);
    }
  };
  useEffect(() => {
    if (agentNumbers.length === 0) {
      api();
    }
    return () => {};
  }, [agentNumbers, session_agent_numbers]);

  useEffect(() => {
    if (props.ticker_initial_agent_number) {
      reFormatOptions(props.ticker_initial_agent_number);
    }
  }, [props.ticker_initial_agent_number]);

  return (
    <div className="row tel-select">
      <div className="col-12 flex-d">
        <div className="demo-wrapper">
          <OpcSelect
            type="agent_number"
            placeholder="Agent"
            searchPlaceholder="Search Agent"
            selected={selected}
            onSelect={onSelect}
            showSelectedLabel={showSelectedLabel}
            showSecondarySelectedLabel={showSecondarySelectedLabel}
            showOptionLabel={showOptionLabel}
            showSecondaryOptionLabel={showSecondaryOptionLabel}
            customLabels={customLabels}
            countries={valueCodes}
            searchable={searchable}
            selectButtonClassName="opselect-form-field-outline"
          />
        </div>
      </div>
    </div>
  );
};
